import React from "react";

interface SlideImage {
  node: {
    sourceUrl: string;
    altText: string;
  };
}

interface BrandItem {
  title: string;
  imagesSlider: SlideImage[];
}

interface IndustryPartnersProps {
  data: {
    brandAreaRepeater: BrandItem[];
  };
}

const IndustryPartners: React.FC<IndustryPartnersProps> = ({ data }) => {
  return (
    <div className="brand-area-three section-pt-30 mb-30 mt-30">
      <div className="container">
        <div className="row gap-5">
          {data?.brandAreaRepeater.map((item, index) => (
            <div className="col-12" key={index}>
              <div className="section__title text-center mb-40">
                <h2 className="title" style={{ fontSize: 25 }}>
                  {item.title}
                </h2>
              </div>
              <div className="industry_partener_slider">
                <div
                  className={`industry_partener-content ${
                    index % 2 === 0 ? "right-to-left" : "left-to-right"
                  }`}
                >
                  {item?.imagesSlider.map((slide: any, key: number) => (
                    <div className="brand__item-two" key={key}>
                      <img
                        src={slide?.image?.node?.sourceUrl}
                        alt={slide?.image?.node?.altText}
                        width={182}
                        height={134}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IndustryPartners;
